require('./welcomeController');
require('../shared/featuredImage/featuredImageDirective');

"use strict";

angular.module('app.welcome', [
    'app.welcome.welcomeController',
    'app.shared.featuredImage.featuredImageDirective'
])
    .config([
        '$stateProvider', 'PRODUCT', function ($stateProvider, product) {

            let welTemplate = 'components/welcome/welcomeView.html';
            if (product.Code != 'htv') {
                welTemplate = 'assets/templates/' + product.Code + '/welcome/welcomeView.html';
            }

            $stateProvider.state('welcome', {
                url: '/',
                templateUrl: welTemplate,
                controller: 'app.welcome.welcomeController'
            });
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/welcome/welcome.js